import { state, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import LocalStorageService from "../services/localStorage";
export var navigateNext = function (step, navigate) {
    var _a;
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var flow = localStorageService.getStepStored().steps[0].flow;
    if (!flow) {
        return;
    }
    var flowData = (_a = flow.metadata) === null || _a === void 0 ? void 0 : _a.navigation.flowStep.steps;
    var nextStep = flowData.find(function (item) { return item.name === step; });
    var nextIndex;
    var nextElement;
    var route = "/";
    if (nextStep) {
        nextIndex = flowData.indexOf(nextStep);
        nextElement = flowData[nextIndex + 1];
        route = nextElement.route;
    }
    navigate(route);
};
export var navigateBack = function (step, navigate) {
    var _a;
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var flow = localStorageService.getStepStored().steps[0].flow;
    if (!flow) {
        return;
    }
    var flowData = (_a = flow.metadata) === null || _a === void 0 ? void 0 : _a.navigation.flowStep.steps;
    var nextStep = flowData.find(function (item) { return item.name === step; });
    var nextIndex;
    var nextElement;
    var route = "/";
    if (nextStep) {
        nextIndex = flowData.indexOf(nextStep);
        nextElement = flowData[nextIndex - 1];
        route = nextElement.route;
    }
    navigate(route);
};
/**
 * @param step - current step
 * @param breadcrumb - boolean to determine if breadcrumb or steps
 * @returns - array of steps or breadcrumbs
 */
export var stepProgress = function (step, breadcrumb) {
    var _a;
    var steps = [];
    var crumbs = [];
    var foundStep = false;
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var flow = localStorageService.getStepStored().steps[0].flow;
    if (!flow) {
        return [];
    }
    var flowData = (_a = flow.metadata) === null || _a === void 0 ? void 0 : _a.navigation.flowStep.steps;
    var currentIndex = flowData === null || flowData === void 0 ? void 0 : flowData.findIndex(function (p) { return p.name == step; });
    //currentStep?.stepId;
    var index = 0;
    flowData === null || flowData === void 0 ? void 0 : flowData.forEach(function (item) {
        index++;
        if (breadcrumb) {
            foundStep = item.name === step ? true : foundStep;
            if (foundStep === false) {
                crumbs.push({
                    key: "",
                    name: item.label,
                    ariaCurrent: "",
                });
            }
        }
        else {
            steps.push({
                id: (index - 1).toString(),
                name: item.label,
                code: item.name,
                state: state.initialState,
            });
        }
    });
    steps.forEach(function (item) {
        if (Number(item.id) < (currentIndex !== null && currentIndex !== void 0 ? currentIndex : 0)) {
            item.state = state.complete;
        }
        if (Number(item.id) == currentIndex) {
            item.state = state.inProgress;
        }
        if (Number(item.id) > (currentIndex !== null && currentIndex !== void 0 ? currentIndex : 0)) {
            item.state = state.initialState;
        }
    });
    return breadcrumb ? crumbs : steps;
};
